import { IS_FLIPGIVE } from 'common/env';

export const getCurrency = () => {
    return IS_FLIPGIVE ? 'CAD' : 'USD';
};
